import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppBreadcrumb from "../../Shared/AppBreadcrumb";
import FecthingSpinner from "../../Shared/FecthingSpinner";
import httpService from "../../../services/http.service";
import MyOpinionLogo from "../../../assets/images/MyOpinion_Logo_Head.png";

const PaymentCountries = () => {
  const [data, setData] = useState([]);
  const [fetching, setFetching] = useState(true);
  const [search, setSearch] = useState("");

  const fetchData = useCallback(async () => {
    setFetching(true);
    try {
      const response = await httpService.get("/payment-countries");
      if (response?.data?.success) {
        setData(Array.isArray(response.data.data) ? response.data.data : []);
      }
    } catch (error) {
      console.error("Erreur chargement pays:", error?.response?.data || error);
      setData([]);
    } finally {
      setFetching(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const filteredCountries =
    !search.trim()
      ? data
      : data.filter((item) => {
          const term = search.toLowerCase().trim();
          return (
            item?.name_fr?.toLowerCase().includes(term) ||
            item?.name_en?.toLowerCase().includes(term) ||
            item?.code?.toLowerCase().includes(term)
          );
        });

  return (
    <div className="container-fluid payment-countries-admin-page">
      <AppBreadcrumb title="Liste des pays de paiement" />
      {fetching ? (
        <FecthingSpinner />
      ) : (
        <div className="card border-0 shadow-sm" style={{ borderRadius: "12px" }}>
          <div className="p-3 border-bottom bg-white">
            <div className="row align-items-center">
              <div className="col-md-6">
                <h5 className="mb-0 text-secondary">Liste des pays de paiement</h5>
              </div>
              <div className="col-md-6 mt-2 mt-md-0">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Rechercher (nom ou code)..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-hover table-custom spacing8 mb-0">
              <thead>
                <tr>
                  <th>Drapeau</th>
                  <th>Nom</th>
                  <th>Code</th>
                  <th>Monnaie</th>
                  <th>Code d&apos;appel</th>
                  <th>Statut</th>
                  <th className="text-right" style={{ width: 56 }}>
                    <span className="sr-only">Actions</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredCountries?.map((item) => (
                  <tr key={item?.id}>
                    <td className="w60">
                      <Link to={`/payment-countries/${item.id}/methods`}>
                        {item?.flag ? (
                          <img
                            src={item.flag || MyOpinionLogo}
                            alt=""
                            className="w40"
                            style={{ objectFit: "cover" }}
                          />
                        ) : (
                          <div
                            style={{
                              width: 40,
                              height: 25,
                              paddingTop: 2,
                              backgroundColor: "#d1d1d1",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <span className="small">{item?.code}</span>
                          </div>
                        )}
                      </Link>
                    </td>
                    <td style={{ fontWeight: "500" }}>
                      <Link
                        to={`/payment-countries/${item.id}/methods`}
                        className="text-secondary"
                      >
                        {item?.name_fr} ({item?.name_en})
                      </Link>
                    </td>
                    <td style={{ fontWeight: "500" }}>{item?.code}</td>
                    <td style={{ fontWeight: "500" }}>
                      {item?.currency_name} ({item?.currency_code})
                    </td>
                    <td style={{ fontWeight: "500" }}>{item?.dial_code}</td>
                    <td>
                      <span
                        className={`badge ${
                          item?.status ? "badge-success" : "badge-secondary"
                        }`}
                      >
                        {item?.status ? "Actif" : "Inactif"}
                      </span>
                    </td>
                    <td className="text-right">
                      <div
                        className="d-inline-flex justify-content-end"
                        style={{ gap: "6px" }}
                      >
                        <Link
                          to={`/payment-countries/${item.id}/methods`}
                          className="btn btn-sm btn-outline-success d-inline-flex align-items-center justify-content-center p-0"
                          style={{ width: 34, height: 34, borderRadius: "8px" }}
                          title="Méthodes"
                          aria-label="Méthodes pour ce pays"
                        >
                          <i className="icon-credit-card" aria-hidden />
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentCountries;
